<template>
  <div class="content flex flex-1 h-0">
    <div class="section bg-ff flex-1 flex-column">
      <div class="title flex w-100 align-center">
        <div class="decoration-line mr-5"></div>
        <div class="font-16-46b8b0 font-bold">实景图</div>
      </div>
      <div class="flex-1 h-0 overflow-y mb-10">
        <el-scrollbar style="height: 100%;">
          <div class="flex flex-wrap pt-20 pb-10 plr-10 list">
            <div class="picItem flex-column" v-for="(item, index) in pic" :key="index" @click="onImg(item.filePath)">
              <div :style="{'height': picHeight}">
                <el-image :src="item.filePath" fit="cover" :alt="item.name" class="w-100 h-100" :preview-src-list="srcList"></el-image>
              </div>
              <div class="bg-f3f4f7 p-10 text-left">
                <div class="font-12-30313a mb-2 text-overflow">{{item.name}}</div>
                <div class="font-12-b9b9b9">上传： {{item.foundName}} {{Utils.formatDate2(item.createTime)}}</div>
              </div>
            </div>
          </div>
        </el-scrollbar>
      </div>
      <div class="mb-10 mlr-20">
        <Pagination :pageSize="pageSize" v-model="pageNo" :pageTotal="pageTotal" :total="total" @on-jump="jump"></Pagination>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
export default {
  name: 'RealisticPic',
  components: {Pagination},
  props: {
    customerId: String,
    picHeight: String
  },
  data () {
    return {
      page: 1,
      limit: 25,
      pageSize: 0,
      pageNo: 0,
      pageTotal: 25,
      total: 0,
      pic: [],
      srcList: []
    }
  },
  created () {},
  mounted () {
    this.getPic()
  },
  methods: {
    getPic () {
      this.axios.post(`${this.$store.state.API_URL_9010}/customerFile/queryForPage`, {
        classifyId: 2,
        customerId: this.customerId,
        page: this.page,
        limit: this.limit,
        status: 2
      }).then(res => {
        if (res.data.success) {
          this.pic = res.data.data.list
          this.pageSize = res.data.data.pages
          this.pageNo = this.page
          this.pageTotal = res.data.data.size
          this.total = res.data.data.total
        }
      })
    },
    onImg (item) {
      this.srcList = []
      this.srcList.push(item)
    },
    jump (page) { // 分页
      this.page = page.pageNo
      this.limit = page.pageTotal
      this.getPic()
    }
  }
}
</script>

<style lang="scss" scoped>
  .overflow-y{
    overflow-y: auto;
  }
  .section{
    border-radius: 4px;
  }
  .decoration-line{
    width: 4px;
    height: 16px;
    background-color: #46b8b0;
    border-radius: 4px;
  }
  .section .title{
    height: 36px;
    padding-left: 20px;
    border-bottom: 1px solid #e2e2e2;
  }
  .picItem {
    width: calc((100% - 50px) / 5);
    margin: 0 5px 10px;
  }
  .section /deep/ .el-scrollbar__wrap {
    overflow-x: hidden;
  }
  .content{
    // padding: 10px 20px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/successfulCases/components/RealisticPic.vue